import { render, staticRenderFns } from "./SeminarEdit.vue?vue&type=template&id=b890a51c&scoped=true&lang=pug&"
import script from "./SeminarEdit.vue?vue&type=script&lang=ts&"
export * from "./SeminarEdit.vue?vue&type=script&lang=ts&"
import style0 from "./SeminarEdit.vue?vue&type=style&index=0&id=b890a51c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b890a51c",
  null
  
)

export default component.exports